// Client-side spendability for a store-credit note (P2c till picker).
//
// The server enforces expiry lazily (a note's stored status stays "active"
// until something touches it), so the till must derive what is actually
// spendable right now from status + expiryUtc, exactly as the server's
// RedeemableRemaining does: a note is spendable only while its status is
// "active" and it has not passed its expiry. The authoritative debit still
// happens server-side in RedeemAsync - this is the till's optimistic view so
// the cashier never tries to apply a dead note.

import type { ICreditNote } from '../api/model/requests';

export function isCreditNoteRedeemable(
  note: ICreditNote,
  nowMs = Date.now()
): boolean {
  if (note.status !== 'active') return false;
  if (note.remaining <= 0) return false;
  if (note.expiryUtc && Date.parse(note.expiryUtc) <= nowMs) return false;
  return true;
}

// The amount of a note that can be spent right now (0 when not redeemable).
export function creditNoteRedeemable(
  note: ICreditNote,
  nowMs = Date.now()
): number {
  return isCreditNoteRedeemable(note, nowMs) ? note.remaining : 0;
}
